<template>
  <el-dialog
    :title="listName"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    @open="fetchContacts"
    @closed="clearContacts">
    <loader v-if="$apollo.loading" msg="Loading Contacts" />
    <div v-for="contact in listContacts" :key="contact.id">
      <span>{{contact.firstName}} {{contact.lastName}}</span>
    </div>
  </el-dialog>
</template>

<script>
import contactListContactsQuery from '@/graphql/contacts/contactListContacts.gql';
import mailChimpListContactsQuery from '@/graphql/contacts/mailChimpListContacts.gql';
import Loader from '@/components/common/Loader';

export default {
  name: 'ContactListDialog',
  components: {
    Loader,
  },
  props: {
    contactAccount: {
      type: Object,
      required: true,
    },
    listId: {
      type: String,
      required: true,
    },
    listName: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.isVisible;
      },
      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
  },
  data: () => ({
    listContacts: [],
    skipContactListContactsQuery: true,
    skipMailChimpListContactsQuery: true,
  }),
  apollo: {
    $client: 'apiv2',
    contactListContacts: {
      query: contactListContactsQuery,
      skip() { return this.skipContactListContactsQuery; },
      variables() {
        return {
          id: this.contactAccount.id,
          listId: this.listId,
        };
      },
      result({ data, loading }) {
        this.listContacts = !loading ? data.contactListContacts : [];
      },
    },
    mailChimpListContacts: {
      query: mailChimpListContactsQuery,
      skip() { return this.skipMailChimpListContactsQuery; },
      variables() {
        return {
          id: this.contactAccount.id,
          listId: this.listId,
        };
      },
      result({ data, loading }) {
        this.listContacts = !loading ? data.mailChimpListContacts : [];
      },
    },
  },
  methods: {
    fetchContacts() {
      switch (this.contactAccount.providerName) {
        case 'constant_contact':
          this.skipContactListContactsQuery = false;
          this.$apollo.queries.contactListContacts.refetch({
            id: this.contactAccount.id, listId: this.listId,
          });
          break;
        case 'mail_chimp':
          this.skipMailChimpListContactsQuery = false;
          this.$apollo.queries.mailChimpListContacts.refetch({
            id: this.contactAccount.id, listId: this.listId,
          });
          break;
        default: break;
      }
    },
    clearContacts() {
      this.listContacts = [];
    },
  },
};
</script>


// WEBPACK FOOTER //
// ContactsListDialog.vue?d713ae7a